import { SelectOption } from "@cinesys/ui/components";
import { GamebookWeekStatus } from "../gamebook/service";
import { weekLabel } from "../gamebook/weeks";
import { SPOTTER_STRINGS } from "../strings";

/**
 * `NewRunModal`'s week `Select` options (Monday 12941628059, Seth: "I'm okay with the entire
 * season populating in the dropdown, but only when the opponent is identified should it fill in
 * the additional information"). `useGamebookWeeks` already returns every week in the season
 * (`nflWeekSkeleton()`), generated or not — no new schedule source needed, just stop filtering
 * that list down to `generated` before rendering it.
 *
 * A run needs an already-generated game (`gameId` resolves from `(season, week)` server-side;
 * `POST /anchor-jobs` 404s otherwise — see `filmsGround.ts`), so an ungenerated week is listed
 * but `isDisabled`, with the reason folded into its own `extra` text rather than being silently
 * selectable and failing on submit.
 */
export function gameWeekOptions(weeks: GamebookWeekStatus[]): SelectOption[] {
  const t = SPOTTER_STRINGS.controlRoom.newRun;
  return weeks.map((w) => {
    const matchup = w.opponentCode
      ? `${w.home ? "vs" : "@"} ${w.opponentCode}`
      : undefined;
    return {
      value: w.week,
      label: weekLabel(w.week),
      extra: w.generated
        ? matchup
        : matchup
        ? t.weekMatchupNotGenerated(matchup)
        : t.weekNotGenerated,
      isDisabled: !w.generated,
    };
  });
}
